import React from "react";
import { useNavigate } from "react-router-dom";
import { FileText, UserX, ShieldAlert, Handshake, Flag, AlertTriangle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export default function RaiseDispute() {
  const navigate = useNavigate();
  const { user, openAuth } = useAuth();

  const go = (path) => (user ? navigate(path) : openAuth("signup"));

  const actions = [
    { icon: FileText, title: "File a complaint about a vendor", to: "/file-complaint?as=customer", testid: "rd-vendor" },
    { icon: UserX, title: "File a complaint about a customer", to: "/file-complaint?as=vendor", testid: "rd-customer" },
    { icon: ShieldAlert, title: "Challenge a complaint", to: "/dashboard", testid: "rd-challenge" },
    { icon: Handshake, title: "Request settlement", to: "/dashboard", testid: "rd-settlement" },
    { icon: Flag, title: "Report abuse or privacy violation", to: "/support", testid: "rd-report" },
  ];

  return (
    <div className="ca-container py-12 max-w-4xl">
      <h1 className="font-display text-3xl sm:text-4xl font-bold text-slate-900">Raise a Dispute</h1>
      <div className="mt-4 rounded-2xl border border-amber-200 bg-amber-50 p-5 flex gap-3">
        <AlertTriangle className="h-5 w-5 text-amber-600 shrink-0 mt-0.5" />
        <ul className="text-sm text-amber-800 space-y-1 list-disc pl-4">
          <li>Filing a complaint is not a legal proceeding. ComplaintAdvisor is a neutral technology platform.</li>
          <li>Both parties receive a fair opportunity to respond.</li>
          <li>The platform does not guarantee recovery of money or completion of work.</li>
          <li>Please preserve your original evidence.</li>
          <li>Serious safety threats, crimes, or emergencies should be reported to the appropriate authorities.</li>
        </ul>
      </div>
      <div className="mt-6 grid sm:grid-cols-2 gap-4">
        {actions.map((a) => (
          <button key={a.testid} data-testid={a.testid} onClick={() => go(a.to)}
            className="rounded-2xl border border-slate-200 bg-white p-5 text-left hover:border-teal-brand/40 hover:shadow-sm transition-all flex items-start gap-3">
            <div className="h-10 w-10 rounded-xl bg-teal-brand/10 flex items-center justify-center shrink-0">
              <a.icon className="h-5 w-5 text-teal" />
            </div>
            <span className="font-semibold text-slate-900">{a.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
